/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/axiosInstance.js";
import type { HasPaidQueryResponse, HasPaid400, HasPaid401, HasPaid402, HasPaid404, HasPaid409, HasPaid500 } from "../../types/HasPaid.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/axiosInstance.js";

function getHasPaidUrl() {
  const res = { method: 'GET', url: `/onboarding/base/haspaid` as const }
  return res
}

/**
 * @description Checks if the currently authenticated user has paid and for what.If the user has the 'ROLE_PAID' or 'ROLE_USER' authority, a success response object (payment status, tier and subscription name) is returned. Otherwise, a checkout link is provided with a Payment Required status.
 * @summary Check payment status
 * {@link /onboarding/base/haspaid}
 * @deprecated
 */
export async function hasPaid(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<HasPaidQueryResponse, ResponseErrorConfig<HasPaid400 | HasPaid401 | HasPaid402 | HasPaid404 | HasPaid409 | HasPaid500>, unknown>({ method : "GET", url : getHasPaidUrl().url.toString(), ... requestConfig })
  return res.data
}